import { useCurrentUserData } from '~/root/Auth';
import { MedlyNavButton } from '~/root/Medly';
import { useNavigation } from '../../context';
import { NavigationLink } from '../../NavigationLink';
import { NavigationSection } from '../../NavigationSection';
import { SubNavigation } from '../../SubNavigation';
import { EnterpriseBanner, TenHourTurnaroundBanner } from '../banners';
import { config } from '../config';

export const SubscriptionNavigation = () => {
  const { isMenuCollapsed, isFromHeader } = useNavigation();
  const { marketingCampaigns } = useCurrentUserData();

  const showEnterpriseBanner = !isMenuCollapsed && !isFromHeader;
  const showTenHourTurnaroundBanner = marketingCampaigns?.tenHoursTurnaround;
  const showBannerContainer = showEnterpriseBanner || showTenHourTurnaroundBanner;

  return (
    <>
      <NavigationSection>
        <NavigationLink {...config.links.myOrders} />
        <NavigationLink {...config.links.myTeam} />
        <SubNavigation {...config.subMenus.billing}>
          <NavigationLink {...config.links.billingOverview} />
          <NavigationLink {...config.links.billingPaymentHistory} />
          <NavigationLink {...config.links.billingCreditHistory} />
          <NavigationLink {...config.links.billingCreditPacks} />
        </SubNavigation>
        <NavigationLink {...config.links.billingSubscriptions} />
        <NavigationLink {...config.links.holidayCalendar} />
        <NavigationLink {...config.links.customFields} />
        <NavigationLink {...config.links.styleTemplates} />
        <NavigationLink {...config.links.capacityOverview} />
        <SubNavigation {...config.subMenus.settings}>
          <NavigationLink {...config.links.userDetails} />
          <NavigationLink {...config.links.security} />
        </SubNavigation>
        <NavigationLink {...config.links.needHelp} />
      </NavigationSection>

      <MedlyNavButton />

      {showBannerContainer && (
        <div className="lg:mx-0 mx-2 lg:space-y-2 space-y-3">
          {showEnterpriseBanner && <EnterpriseBanner />}
          {showTenHourTurnaroundBanner && <TenHourTurnaroundBanner />}
        </div>
      )}
    </>
  );
};
